import UserList from "./UserList";
import UserEdit from "./UserEdit";
import UserRoles from "./UserRoles.vue";
import UserProfile from "./UserProfile.vue";

module.exports = [
    {path: '/user/list', component: UserList, meta: {title: 'Users'}},
    {path: '/user/new', component: UserEdit, meta: {title: 'New User'}},
    {path: '/user/edit/:id?', component: UserEdit, meta: {title: 'Edit User'}},
    {path: '/user/roles', component: UserRoles, meta: {title: 'Roles'}},
    {path: '/user/profile', component: UserProfile, meta: {title: 'Account'}},
]
